import * as Accordion from '@radix-ui/react-accordion';
import { motion } from 'framer-motion';

import { openNavStyles } from '@/components/modules/app-navigation/open';
import { navItemVariants } from '@/components/modules/app-navigation/utils/transitions';

export interface OpenItemContentProps {
  isOpen?: boolean;
  visibility: 'visible' | 'hidden';
  children: React.ReactElement;
}

const OpenItemContent = ({ visibility, isOpen, children }: OpenItemContentProps) => {
  const { subNav } = openNavStyles({ isOpen });
  return (
    <Accordion.Content className={subNav()}>
      <motion.div variants={navItemVariants} animate={visibility}>
        {children}
      </motion.div>
    </Accordion.Content>
  );
};

export { OpenItemContent };
